import { usePinStoryMutation } from 'components/Story/graphql/pinStory.types'
import { useUnpinStoryMutation } from 'components/Story/graphql/unpinStory.types'
import { useCallback, useLayoutEffect, useRef } from 'react'
import { useParams } from 'react-router-dom'
import { TStory } from '../../../components/Story'

export const useStoryPinning = (story: TStory, storyRef: React.RefObject<HTMLDivElement> ) => {
  const { id: projectId } = useParams<{ id: string }>()
  const cacheUpdated = useRef(false)
  const pinToggled = useRef(false)
  const firstUpdate = useRef(true)

  const [pinStoryMutation, { loading: isPinning }] = usePinStoryMutation({
    update(cache) {
      cache.modify({
        fields: {
          getFeeds() {},
          getFeedsByCampaignId() {}
        }
      })
      cacheUpdated.current = true
    }
  })
  const [unpinStoryMutation, { loading: isUnpinning }] = useUnpinStoryMutation({
    update(cache) {
      cache.modify({
        fields: {
          getFeeds() {},
          getFeedsByCampaignId() {}
        }
      })
      cacheUpdated.current = true
    }
  })

  useLayoutEffect(() => {
    if (cacheUpdated && pinToggled.current && !(firstUpdate.current) ) {
      storyRef?.current?.scrollIntoView({
        block: 'center',
        behavior: 'smooth'
      })
      cacheUpdated.current = false
      pinToggled.current = false
    }
    firstUpdate.current = false
  }, [story.pinned, storyRef])

  const toggleStoryPinState = useCallback(
    () => {
      pinToggled.current = true
      return projectId ? story.pinned ? unpinStoryMutation({
        variables: {projectId}
      }) : pinStoryMutation({
        variables: {projectId: projectId, storyId: story.id}
      }) : null
    },
    [pinStoryMutation, unpinStoryMutation, story.pinned, story.id, projectId]
  )

  const loading = isPinning || isUnpinning
  return {
    toggleStoryPinState,
    loading
  }
}
